import React from "react";
import Slider from "react-slick";
const HomeSlider = () => {
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 3000,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    adaptiveHeight: true,
  };
  return (
    <>
      <div className="slider-sec">
        <Slider {...settings}>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/slider.png"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div>

          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/slider12.jpeg"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/slider8.jpeg"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div>

          {/* <div className="item">
            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/slider10.jpg" className="d-block w-100" alt="St. Francis Xavier School" />
          </div> */}

          {/* <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/slider9.jpg"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div> */}

          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/slider5.jpg"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/slider6.jpg"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/slider11.jpg"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/slider1.jpg"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/slider2.jpg"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/slider3.jpg"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/slider4.jpg"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/slider7.jpg"
              className="d-block w-100"
              alt="St. Francis Xavier School"
            />
          </div>
        </Slider>
      </div>
    </>
  );
};

export default HomeSlider;
